import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { BreadcrumbService } from 'xng-breadcrumb';

import { ActivatedRouteSnapshot } from '@angular/router';
import { BaseDtoModel } from '@heitown/common-dto';
import { FacadeInterface, SharedFacadeInterface } from '@heitown/frontend-common';
import { RouterService } from '@heitown/frontend-routing-utils';

import { BaseDetailGuard } from './base-detail.guard';

export class DetailGuard<T extends BaseDtoModel>
  extends BaseDetailGuard<T>
  
{
  constructor(
    protected sharedFacade: SharedFacadeInterface<T>,
    protected facade: FacadeInterface<T>,
    breadcrumb: BreadcrumbService,
    routerService: RouterService
  ) {
    super(breadcrumb, routerService);
  }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const entityId = route.params['entityId'];

    return this.hasEntity(
      entityId,
      this.routerService.isViewOnlyMode(route),
      this.routerService.isAddMode(route) ||
        this.routerService.isViewOnlyMode(route),
      route
    );
  }

  getOptions(route: ActivatedRouteSnapshot): any {
    return undefined;
  }

  hasEntity(
    id: string,
    disableForm: boolean,
    disableBreadcrumb: boolean,
    route: ActivatedRouteSnapshot
  ): Observable<boolean> {
    return this.sharedFacade.allEntities$.pipe(
      map((items) => {
        return items.find((i) => i.id == id);
      }),
      map((item) => {
        const result = id === '0' || item != null;
        if (result) {
          this.facade.formInitialize(item, disableForm, this.getOptions(route));
          this.setBreadcrumb(item, disableBreadcrumb);
        } else {
          this.sharedFacade.loadSingle(id);
        }
        return result;
      }),
      filter((res) => !!res),
      take(1)
    );
  }
}
